
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { FgStockReportModel } from "./fg-stock-report.model";


export class FgStockReportResponse extends GlobalResponseObject{
    data?: FgStockReportModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: FgStockReportModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}